/* global window */
import { pages } from 'SiteConfigs/pages-config';

const optionsRouteHelper = (country, symbol, tier) => {
	const { code } = tier || {};

	switch (code) {
		case 'IEE':
		case 'WGE':
			return pages.stocksOptions.route.replace(':country', country).replace(':symbol', symbol);
		default:
			return pages.stocksSnapshot.route.replace(':country', country).replace(':symbol', symbol);
	}
};

export const getRoute = (id, country, symbol, tier) => {
	const { noEtfCenter } = tier || {};
	switch (id) {
		// ETFs
		case 1:
		case 18:
			return noEtfCenter
				? pages.fundCentreSnapShot.route.replace(':country', country).replace(':symbol', symbol)
				: pages.etfCentreSnapshot.route.replace(':country', country).replace(':symbol', symbol);
		// Funds
		case 5:
			return pages.fundCentreSnapShot.route.replace(':country', country).replace(':symbol', symbol);
		// Options
		case 2:
			return optionsRouteHelper(country, symbol, tier);
		// Equities
		case 3:
		case 7:
		case 84:
		default:
			return pages.stocksSnapshot.route.replace(':country', country).replace(':symbol', symbol);
	}
};

export const isEquityId = id => {
	return id === 2 || id === 3 || id === 7 || id === 84;
};

export const isFundId = id => {
	return id === 5;
};

const symbolRedirectHelper = (xrefResult, user) => {
	if (xrefResult) {
		const {
			classification,
			exchange,
			symbol
		} = xrefResult;
		const { tier } = user || {};
		const { countryIso } = exchange || {};
		const { id } = classification || {};
		if (countryIso && symbol && id) {
			window.location.href = getRoute(id, countryIso, symbol, tier);
		}
	}
};

export default symbolRedirectHelper;
